import { Button, Drawer, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { CrudUsers } from '../../../api/admin/CrudUsers.api';
import { cleanDigitSectionValue } from '@mui/x-date-pickers/internals/hooks/useField/useField.utils';
import LoaderData from '../../../component/LoaderData';

export const Usuarios = () => {

    const [IsLoadding, setIsLoadding] = useState(false);

    const [TxtFing, setTxtFing] = useState();
    const [reload, setReload] = useState(1);

    const [usuariosList, setUsuariosList] = useState([]);
    const [usuariosListBKP, setUsuariosListBKP] = useState([]);
    
    const [usuarioSelected, setUsuarioSelected] = useState();



    //DRAWER USUARIOS
    const [state_U, setState_U] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
    });
    const toggleDrawer_U = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if(anchor === "bottom" && open){
            //LOGIC WHEN DRAWER CLOSER
        }
        setState_U({ ...state_U, [anchor]: open });
    };

    //CRUD USUARIOS
    const crudUsuarios = (action, data) => {

        //logica para crud
        const createUsuario = async (data) => {
        }
        const readUsuario = async () => {
            setIsLoadding(true);
            let respUsuario = await CrudUsers({action: "READ" })
            // console.log(respUsuario)
            if(respUsuario?.length > 0){
                await setUsuariosList(respUsuario);
            }
            await setIsLoadding(false);
        }
        const updateUsuario = async (data) => {
            // console.log("UPDATE", data)
            let isDelete = window.confirm("¿Esta seguro de editar el usuario seleccionado?");
            if(isDelete) {
                let resp = await CrudUsers({data, action: "UPDATE"});
                // console.log(resp)
                await crudUsuarios("READ");
                await setState_U({...state_U,["bottom"]: false});
                // alert("Usuario editado correctamente");
                await setReload(reload + 1);
                await setTxtFing("");
            }
        }

        const deleteUsuario = async (data) => {
            // console.log("DELETE", data)
            let isDelete = window.confirm("¿Esta seguro de eliminar el usuario seleccionado?");
            if(isDelete) {
                let resp = await CrudUsers({data, action: "DELETE"});
                await setTxtFing("");
                await crudUsuarios("READ");
                alert("Usuario eliminado correctamente");
            }
        }

        switch (action) {
            case "CREATE":
                createUsuario(data);
                return;
            case "READ":
                readUsuario();
                return;
        
            case "UPDATE":
                updateUsuario(data);
                return;

            case "DELETE":
                deleteUsuario(data);
                return;
        }
    }

    useEffect(() => {
        crudUsuarios("READ");
        return () => {
            crudUsuarios("READ")
        }
    }, [])

    const handleFind = async (value) => {
        // console.log("solicita", value)
        if(value?.length > 3){
            let filter = usuariosList.filter((item) => {
                return String(item.rut).toUpperCase().includes(value) || String(item.nombre).toUpperCase().includes(value);
            });
            // console.log(filter);
            setUsuariosListBKP(filter);
        }else{
            setUsuariosListBKP();
        }
    }

    useEffect(() => {
        if(TxtFing != undefined || TxtFing != ""){
            handleFind(TxtFing);
        }
    }, [TxtFing, reload])
    

    return (<>
        <div className='container'>
            <div className='row'>
                <div className='col-12 fondo-celeste container-header-minipage mb-2 pt-3'>
                    <h1 className='lead text-white'>
                        <b>Pasajero</b>
                    </h1>
                </div>
                
                <div className='col-12 mt-2 mb-2'>
                    {/* buscador de usuario */}
                    <div className='row'>
                        <div className='col-12 col-md-4'>
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-basic"
                                label="Buscador"
                                variant="outlined"
                                value={TxtFing}
                                onChange={(e) => setTxtFing(e.target.value.toUpperCase())}
                            />
                        </div>
                        <div className='col-12 col-md-4'>
                        </div>
                    </div>
                </div>
                <div className='col-12 mb-5'>
                    <table className='table table-sm table-striped table-hover'>
                        <thead className='fondo-gris text-white'>
                            <tr>
                                <th>Rut</th>
                                <th>Nombre</th>
                                <th>Telefono</th>
                                <th>Area</th>
                                <th className='text-center'>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                usuariosListBKP?.length > 0 ? usuariosListBKP.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.rut}</td>
                                        <td>{item.nombre}</td>
                                        <td>{item.telefono}</td>
                                        <td>{item.area}</td>
                                        <td className='text-center'>
                                            
                                            <span
                                                onClick={() => {
                                                    setState_U({...state_U,["bottom"]: true});
                                                    setUsuarioSelected(item);
                                                    // setCambioClave("");
                                                    // crudUsuarios("UPDATE", item);
                                                }}
                                                className='click hov'>
                                                <EditIcon color='success' />
                                            </span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span
                                                onClick={() => {
                                                    crudUsuarios("DELETE", item);
                                                }}
                                                className='click hov'>
                                                    <DeleteForeverIcon color='error' />
                                            </span>
                                            
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={5} className='text-center'>Para Buscar pasajeros comience a escribir en el cuadro de búsqueda.</td>
                                    </tr>
                                )

                            }
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        {/* DRAWER PARA EDITAR USUARIO */}
        <Drawer
            anchor={"bottom"}
            open={state_U["bottom"]}
            onClose={toggleDrawer_U("bottom", false)}
        >
          <div className='container-fluid mb-5'>
            <div className='row'>
                <div className='col-12 text-white mb-5 py-3 mb-2 bg-dark'>
                    <span className='lead'>EDITAR USUARIO</span>
                </div>
                <div className='col-12 col-md-4 mt-2'>
                    <TextField
                        fullWidth
                        size='small'
                        id="outlined-basic"
                        label="NOMBRE"
                        variant="outlined"
                        placeholder='NOMBRE APELLIDO APELLIDO'
                        value={usuarioSelected?.nombre}
                        onChange={(e)=>setUsuarioSelected({...usuarioSelected, nombre:e.target.value.toUpperCase()})}
                    />
                </div>
                <div className='col-12 col-md-2 mt-2'>
                    <TextField
                        fullWidth
                        size='small'
                        id="outlined-basic"
                        label="RUT"
                        variant="outlined"
                        value={usuarioSelected?.rut}
                        onChange={(e)=>setUsuarioSelected({...usuarioSelected, rut:e.target.value.toUpperCase()})}
                    />
                </div>
                <div className='col-12 col-md-2 mt-2'>
                    <TextField
                        fullWidth
                        size='small'
                        id="outlined-basic"
                        label="TELEFONO"
                        variant="outlined"
                        value={usuarioSelected?.telefono}
                        onChange={(e)=>setUsuarioSelected({...usuarioSelected, telefono:e.target.value.toUpperCase()})}
                    />
                </div>
                <div className='col-12 col-md-2 mt-2'>
                    <TextField
                        fullWidth
                        size='small'
                        id="outlined-basic"
                        label="AREA"
                        variant="outlined"
                        value={usuarioSelected?.area}
                        onChange={(e)=>setUsuarioSelected({...usuarioSelected, area:e.target.value.toUpperCase()})}
                    />
                </div>
            

                <div className='col-12 mt-2 text-right'>
                    <Button
                        variant="contained"
                        onClick={()=>crudUsuarios("UPDATE",usuarioSelected)}>EDITAR</Button>
                </div>
            </div>
          </div>
        </Drawer>

        {
            IsLoadding &&  <LoaderData />
        }
      </>
    )
}
